import {claimsUrl, claimsV2Url, policyClaimIdUrl, policyClaimsUrl} from "./EndpointService.js";
import {apiFetch, policyApiFetch} from "./ApiService.js";
import themeContext from "../components/ThemeContext.js";

export const getClaimsV2 = async (token_arg, page, size, filter, personId, vehicleId) => {
    let url = `${claimsV2Url}`;

    if (page === 0 || page) url += `?page=${page}`;
    if (size) url += `${(page === 0 || page) ? '&' : '?'}size=${size}`;
    if (filter) url += `${(page === 0 || page) || size ? '&' : '?'}filter=${filter}`;
    if (personId) url += `${(page === 0 || page) || size || filter ? '&' : '?'}personId=${personId}`;
    if (vehicleId) url += `${(page === 0 || page) || size || filter || personId ? '&' : '?'}vehicleId=${vehicleId}`;

    try {
        return await apiFetch(url, token_arg);
    } catch (error) {
        return null;
    }
};

export const getPolicyClaims = async (token_arg, page, size, personId) => {
    let url = `${policyClaimsUrl}?q[s]=eventdate desc`;

    if (page === 0 || page) url += `&page=${page}`;
    if (size) url += `${(page === 0 || page) ? '&' : '?'}per_page=${size}`;
    if (personId) url += `${(page === 0 || page) || size ? '&' : '?'}q[policyholder_id_eq]=${personId}`;

    try {
        return await policyApiFetch(url, token_arg);
    } catch (error) {
        return null;
    }
};

export const CLAIM_STATUS = {
    CLOSED_GREEN: {
        label: 'desktop.claims.closed claim',
        color: themeContext.color.green,
        background: themeContext.color.green10
    },
    CLOSED_RED: {
        label: 'desktop.claims.closed claim',
        color: themeContext.color.red,
        background: themeContext.color.red10
    },
    OPEN: {
        label: 'desktop.claims.open',
        color: themeContext.color.main,
        background: themeContext.color.main10
    },
    WITHOUT_SEQUEL: {
        label: 'desktop.claims.without sequel',
        color: themeContext.color.neutral400,
        background: themeContext.color.neutral100
    },
}

export const translateCloseType = (value) => {
    switch (value.closetype) {
        case 'CIRCOSTANZA DENUNCIATA A COMPAGNIA':
            value.closetype = 'SINISTRO CHIUSO';
            break;
        case 'GESTIONE LEGALE CLIENTE':
            value.closetype = 'SINISTRO CHIUSO';
            break;
        case 'LIQUIDATO A CARROZZERIA':
            value.closetype = 'SINISTRO CHIUSO';
            break;
        case 'LIQUIDATO':
            value.closetype = 'SINISTRO CHIUSO';
            break;
        case 'RESPINTO DALLA COMPAGNIA':
            value.closetype = 'SINISTRO CHIUSO';
            break;
        case 'REVOCA MANDATO - SENZA SEGUITO':
            value.closetype = 'SINISTRO CHIUSO';
            break;
        case 'SENZA SEGUITO':
            value.closetype = 'SENZA SEGUITO';
            break;
        case 'DANNO IN FRANCHIGIA':
            value.closetype = 'SINISTRO CHIUSO';
            break;
        default:
            value.closetype = 'SINISTRO APERTO';
            break;
    }
    return value
}

export const translateActionType = (value) => {
    switch (value) {
        case 'denuncia_compagnia':
            value = 'Sinistro denunciato alla Compagnia';
            break;
        case 'sollecito_denuncia_compagnia':
            value = 'Sinistro sollecitato alla Compagnia';
            break;
        case 'conferma_apertura_cliente':
            value = 'Apertura sinistro';
            break;
        case 'notifica_riparatore_convenzionato_compagnia':
            value = 'Notifica Compagnia';
            break;
        case 'notifica_perito_compagnia_cliente':
            value = 'Notifica nomina Perito';
            break;
        case 'notifica_medico_legale_cliente':
            value = 'Notifica nomina Medico Legale';
            break;
        case 'richiesta_informazioni_cliente':
            value = 'Richiesta informazioni al Contraente';
            break;
        case 'sollecito_cliente':
            value = 'Sollecito Contraente';
            break;
        case 'invio_documentazione_perito_compagnia':
            value = 'Invio documentazione al Perito';
            break;
        case 'richiesta_informazioni_perito':
            value = 'Richiesta informazioni al Perito';
            break;
        case 'sollecito_perito_compagnia':
            value = 'Sollecito al Perito';
            break;
        case 'invio_documentazione_compagnia':
            value = 'Invio documentazione Compagnia';
            break;
        case 'richiesta_informazioni_compagnia':
            value = 'Richiesta informazioni Compagnia';
            break;
        case 'sollecito_compagnia':
            value = 'Sollecito Compagnia';
            break;
        case 'invio_atto_liquidazione_quietanza_cliente':
            value = 'Invio atto di liquidazione o quietanza';
            break;
        case 'invio_atto_liquidazione_quietanza_perito_compagnia':
            value = 'Invio atto di liquidazione o quietanza al Perito';
            break;
        case 'invio_atto_liquidazione_quietanza_compagnia':
            value = 'Invio atto di liquidaz/quietanza a compagnia';
            break;
        case 'personalizzata':
            value = 'Azione personalizzata';
            break;
        case 'conferma_apertura_rca_attivo_cliente':
            value = 'Notifica conferma apertura sinistro attivo RCA';
            break;
        case 'notifica_atto_citazione_cliente':
            value = 'Avvenuta notifica di citazione alla Compagnia';
            break;
        case 'interruzione_termini_prescrizione':
            value = 'Interruzione termini di prescrizione';
            break;
    }
    return value
}

export const setClaimStatus = (value, settledValueCents) => {
    if (value === 'SINISTRO CHIUSO' && settledValueCents > 0) {
        return CLAIM_STATUS.CLOSED_GREEN
    } else if (value === 'SINISTRO CHIUSO') {
        return CLAIM_STATUS.CLOSED_RED
    } else if (value === 'SINISTRO APERTO') {
        return CLAIM_STATUS.OPEN
    } else if (value === 'SENZA SEGUITO') {
        return CLAIM_STATUS.WITHOUT_SEQUEL
    }
}

export const getClaim = async (token_arg, claimId) => {
    try {
        return await apiFetch(`${claimsUrl}/${claimId}`, token_arg);
    } catch (error) {
        return null;
    }
};

export const getPolicyClaimDetail = async (token_arg, claimId) => {
    try {
        return await policyApiFetch(`${policyClaimIdUrl}/${claimId}`, token_arg);
    } catch (error) {
        return null;
    }
};

export const getClaimType = (value) => {
    return value.claimtype === null ? `${value.macro?.name} ${value.micro?.name}` : value.claimtype
}
